import { LoadableAfterPaint } from '@confluence/loadable';

export const EndUserRequestUpgradeModalEntrypoint = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndUserRequestUpgradeModal" */ './EndUserRequestUpgradeModal.tsx'
			)
		).EndUserRequestUpgradeModal,
});
